import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

function Advertising() {
  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">Advertising</Card.Title>
                <p className="card-category">
                  Manage advertising campaigns
                </p>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <div className="content">
                  <p>Advertising management content goes here.</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Advertising;